import { Bell, CheckCircle2, Circle, ShoppingBasket, Smartphone } from "lucide-react";

const PLAY_URL = process.env.REACT_APP_PLAY_STORE_URL;
const BADGE = "https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png";
const POINTS = [
  { icon: Bell, text: "Dose reminders right on your phone" },
  { icon: CheckCircle2, text: "Tick off each day's checklist as you go" },
  { icon: ShoppingBasket, text: "Your shopping list in your pocket at the store" },
];
const MOCK = [["Milk thistle · 300 mg", true], ["Warm lemon water", true], ["Dandelion root tea", false], ["Castor oil pack", false]];

const PhoneMock = () => (
  <div aria-hidden className="mx-auto w-[220px] rounded-[2.2rem] border-[6px] border-[#26352f] bg-[#0c1311] p-4 shadow-2xl shadow-teal-900/30 rotate-2">
    <div className="mx-auto h-1.5 w-14 rounded-full bg-[#26352f] mb-4" />
    <div className="text-[10px] font-mono uppercase tracking-widest text-teal-400">Today</div>
    <div className="font-head text-base font-semibold text-emerald-50 mt-0.5">Liver &amp; Gallbladder</div>
    <div className="text-[11px] text-stone-400">Day 3 of 14</div>
    <div className="h-1.5 rounded-full bg-emerald-900/50 mt-2"><div className="h-full w-1/2 rounded-full bg-teal-400" /></div>
    <ul className="mt-4 space-y-2">
      {MOCK.map(([t, done]) => (
        <li key={t} className={`flex items-center gap-2 rounded-lg px-2 py-1.5 text-[11px] ${done ? "bg-emerald-900/40 text-stone-400" : "bg-[#1a2723] text-emerald-50"}`}>
          {done ? <CheckCircle2 className="h-3.5 w-3.5 text-teal-300" /> : <Circle className="h-3.5 w-3.5 text-stone-500" />} {t}
        </li>
      ))}
    </ul>
  </div>
);

export const GetTheApp = () => {
  if (!PLAY_URL) return null;
  return (
    <section data-testid="get-the-app-section" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="pv-in grid md:grid-cols-[1.4fr_1fr] gap-10 items-center rounded-3xl border border-emerald-800/40 bg-[#1a2723] p-8 sm:p-12">
        <div>
          <div className="text-xs font-mono uppercase tracking-widest text-teal-400 flex items-center gap-2"><Smartphone className="h-4 w-4" /> Get the app</div>
          <h2 className="font-head text-3xl sm:text-4xl font-bold text-emerald-50 mt-3">Take your plan with you</h2>
          <p className="text-stone-300 mt-3 max-w-lg">Lumivia for Android uses the same account as the website, so your plans, progress and Premium follow you everywhere.</p>
          <ul className="mt-6 space-y-3">
            {POINTS.map((p) => (
              <li key={p.text} className="flex items-center gap-3 text-stone-200"><p.icon className="h-5 w-5 text-teal-300 shrink-0" /> {p.text}</li>
            ))}
          </ul>
          <a href={PLAY_URL} target="_blank" rel="noopener noreferrer" data-testid="google-play-badge-link"
            className="inline-block mt-7 transition-transform hover:-translate-y-0.5">
            <img src={BADGE} alt="Get it on Google Play" className="h-[72px] -ml-3" />
          </a>
        </div>
        <PhoneMock />
      </div>
    </section>
  );
};
